export type GameCategory = "party" | "quiz" | "social" | "quick";

export interface Game {
  id: string;
  title: string;
  category: string;
  categoryId: GameCategory;
  description: string;
  rating: number;
  minPlayers: number;
  maxPlayers: number;
  imageUrl?: string;
  featured: boolean;
  recommended: boolean;
  fallbackLabel: string;
}

export const games: readonly Game[] = [
  {
    id: "never-have-i-ever",
    title: "Jag har aldrig",
    category: "Festklassiker",
    categoryId: "party",
    description:
      "Ta reda på vad dina vänner egentligen har gjort. Ett enkelt spel som snabbt får igång kvällen.",
    rating: 4.9,
    minPlayers: 3,
    maxPlayers: 12,
    imageUrl:
      "https://pub-d72ce15358f54bd5b2669125a5a87fd3.r2.dev/partycast/cta/partycast-cta-i-have-never.jpg",
    featured: true,
    recommended: true,
    fallbackLabel: "JAG HAR ALDRIG",
  },
  {
    id: "quiz-night",
    title: "Quizkväll",
    category: "Frågesport",
    categoryId: "quiz",
    description:
      "Utmana vännerna i blandade frågor och se resultatet på den stora skärmen mellan rundorna.",
    rating: 4.8,
    minPlayers: 2,
    maxPlayers: 20,
    imageUrl:
      "https://pub-d72ce15358f54bd5b2669125a5a87fd3.r2.dev/partycast/cta/partycast-cta-quiznight.jpg",
    featured: true,
    recommended: true,
    fallbackLabel: "QUIZKVÄLL",
  },
  {
    id: "who-in-the-room",
    title: "Vem i rummet?",
    category: "Lär känna varandra",
    categoryId: "social",
    description:
      "Rösta anonymt på vem i gruppen som bäst passar in på påståendet och avslöja resultatet tillsammans.",
    rating: 4.7,
    minPlayers: 4,
    maxPlayers: 16,
    imageUrl:
      "https://pub-d72ce15358f54bd5b2669125a5a87fd3.r2.dev/partycast/cta/partycast-cta-who-where.jpg",
    featured: true,
    recommended: true,
    fallbackLabel: "VEM I RUMMET?",
  },
  {
    id: "point-out",
    title: "Peka ut",
    category: "Snabba rundor",
    categoryId: "quick",
    description:
      "Alla pekar samtidigt på den person som bäst passar in på frågan. Flest röster vinner rundan.",
    rating: 4.6,
    minPlayers: 3,
    maxPlayers: 12,
    featured: true,
    recommended: false,
    fallbackLabel: "PEKA UT",
  },
  {
    id: "truth-or-dare",
    title: "Sanning eller konsekvens",
    category: "Festklassiker",
    categoryId: "party",
    description:
      "Välj sanning eller konsekvens och låt gruppen bestämma hur modig nästa spelare behöver vara.",
    rating: 4.8,
    minPlayers: 3,
    maxPlayers: 14,
    featured: false,
    recommended: true,
    fallbackLabel: "SANNING ELLER KONSEKVENS",
  },
  {
    id: "music-quiz",
    title: "Musikquiz",
    category: "Frågesport",
    categoryId: "quiz",
    description:
      "Känn igen låtar, artister och klassiska hits tillsammans innan tiden rinner ut.",
    rating: 4.7,
    minPlayers: 2,
    maxPlayers: 20,
    featured: false,
    recommended: true,
    fallbackLabel: "MUSIKQUIZ",
  },
  {
    id: "most-likely",
    title: "Mest sannolikt",
    category: "Lär känna varandra",
    categoryId: "social",
    description:
      "Rösta på vem som mest sannolikt skulle göra det oväntade och jämför gruppens svar.",
    rating: 4.6,
    minPlayers: 4,
    maxPlayers: 16,
    featured: false,
    recommended: true,
    fallbackLabel: "MEST SANNOLIKT",
  },
  {
    id: "five-quick",
    title: "Fem snabba",
    category: "Snabba rundor",
    categoryId: "quick",
    description:
      "Svara på fem blixtsnabba frågor och se vem som tänker snabbast under press.",
    rating: 4.5,
    minPlayers: 2,
    maxPlayers: 12,
    featured: false,
    recommended: true,
    fallbackLabel: "FEM SNABBA",
  },
];
